
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const AcademicGrade = () => {

    const roleId = localStorage.getItem("RoleId");

    const [searchInput, setSearchInput] = useState("");
    const [gradeList, setGradeList] = useState([]);
    const [gradeName, setGradeName] = useState("");
    const [gradeDescription, setGradeDescription] = useState("");
    const [gradeValue, setGradeValue] = useState("");
    const [gradeId, setGradeId] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    // if (roleId === "1") {
    useEffect(() => {
        gradList()
    }, [])
    // }

    function gradList() {
        const getAttendanceList = api.adminGradeList;
        fetch(getAttendanceList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                // console.log(result.data)
                setGradeList(result.data);
            })
            .catch((error) => {
                console.log("Failed to fetch grade list", error);
            })
    }

    const filteredData = gradeList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editGrade(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const slNoRender = (rowData) => {
        return <span>{rowData.gradeTypeId}</span>;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.gradeType}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.gradeTypeDescription}</span>
    }

    const typeValueRender = (rowData) => {
        return <span>{rowData.gradeTypeValue}</span>
    }

    function newGrade() {
        setOpenModal(true);
        setIsEdit(false);
        setGradeName("");
        setGradeDescription("");
        setGradeValue("");
    }

    function editGrade(selectedRow) {
        const gradeId = selectedRow.gradeTypeId;
        const getGradeDetails = api.adminGradeUpdateDetails + '/' + gradeId// "?gradeTypeId=" + gradeId;
        fetch(getGradeDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((gradeResponse) => gradeResponse.json())
            .then((gradeResult) => {
                // const dta = gradeResult.data[0];
                const dta = gradeResult.data;
                setGradeId(dta.gradeTypeId)
                setGradeName(dta.gradeType)
                setGradeDescription(dta.gradeTypeDescription)
                setGradeValue(dta.gradeTypeValue)
                setIsEdit(true)
                setOpenModal(true)
            })
            .catch((error) => {
                console.log("Failed to fetch selected row details.", error);
            })

    }

    function addGrade(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateGrade()
            } else {
                const formData = new FormData();
                formData.append('gradeType', gradeName);
                formData.append('gradeTypeDescription', gradeDescription);
                formData.append('gradeTypeValue', gradeValue)

                const gradeAdd = api.adminGradeCreate;
                fetch(gradeAdd, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
            setOpenModal(false)
        }
    }

    function updateGrade() {
        const formData = new FormData();
        formData.append('gradeTypeId', gradeId);
        formData.append('gradeTypeEdit', gradeName);
        formData.append('gradeTypeDescriptionEdit', gradeDescription);
        formData.append('gradeTypeValueEdit', gradeValue)

        const gradeUpdate = api.adminGradeUpdate;
        fetch(gradeUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the schedule", error)
            })
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == 1 ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="col-lg-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={newGrade}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Grade
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="gradeTypeId"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="GradeType"
                                                    body={nameRender}
                                                    header="Grade Type"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="gradeTypeDescription"
                                                    body={descriptionRender}
                                                    header="Grade Type Description"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="gradeTypeValue"
                                                    body={typeValueRender}
                                                    header="Grade Type Value"
                                                ></Column>
                                                <Column
                                                    body={editDetails}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/ Edit Grade */}
            <Modal
                show={openModal}
                size="md"
                centered
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Grade</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Grade Name</label>
                                <input
                                    id="gradeName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={gradeName}
                                    required
                                    onChange={(e) => {
                                        setGradeName(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Grade Description</label>
                                <textarea
                                    id="gradeDescription"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={gradeDescription}
                                    required
                                    onChange={(e) => {
                                        setGradeDescription(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Grade Value</label>
                                <input
                                    type="number"
                                    id="gradeValue"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={gradeValue}
                                    required
                                    onChange={(e) => {
                                        setGradeValue(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        type="submit"
                        variant="success"
                        onClick={addGrade}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal>
            {/* /Add/ Edit Schedule */}
        </>
    );
};

export default AcademicGrade;